import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { DeliveryPricingRuleDto } from '../model/deliveryPricingRuleDto';
import { CreateDeliveryPricingRuleDto } from '../model/deliveryPricingRuleDto';

import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root',
})
export class DeliveryPricingRulesService {
  protected basePath = '/';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * Get all delivery pricing rules
   * Returns a list of all delivery pricing rules
   */
  public getAllDeliveryPricingRules(
    observe: 'body' = 'body',
    reportProgress: boolean = false
  ): Observable<Array<DeliveryPricingRuleDto>> {
    const headers = this.defaultHeaders;
    
    return this.httpClient.get<Array<DeliveryPricingRuleDto>>(
      `${this.basePath}/api/DeliveryPricingRules/GetAll`,
      {
        headers,
        observe: observe as 'body',
        reportProgress,
      }
    );
  }

  /**
   * Get delivery pricing rule by ID
   * Returns a specific delivery pricing rule by its ID
   * @param id The ID of the delivery pricing rule to retrieve
   */
  public getDeliveryPricingRuleById(
    id: number,
    observe: 'body' = 'body',
    reportProgress: boolean = false
  ): Observable<DeliveryPricingRuleDto> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling getDeliveryPricingRuleById.'
      );
    }

    const headers = this.defaultHeaders;
    
    return this.httpClient.get<DeliveryPricingRuleDto>(
      `${this.basePath}/api/DeliveryPricingRules/GetById?id=${id}`,
      {
        headers,
        observe: observe as 'body',
        reportProgress,
      }
    );
  }

  /**
   * Create a new delivery pricing rule
   * 
   * @param body Delivery pricing rule data to create
   */
  public createDeliveryPricingRule(
    body: CreateDeliveryPricingRuleDto,
    observe: 'body' = 'body',
    reportProgress: boolean = false
  ): Observable<boolean> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling createDeliveryPricingRule.'
      );
    }

    const headers = this.defaultHeaders;

    return this.httpClient.post<boolean>(
      `${this.basePath}/api/DeliveryPricingRules/Post`,
      body,
      {
        headers,
        observe: observe as 'body',
        reportProgress,
      }
    );
  }
}